import { Injectable } from '@angular/core';
import turfLength from '@turf/length';
import { edgeToFeature } from 'src/app/layers/mappers/geojon-mapper';
import { Edge } from '../edges/state/edge.model';

@Injectable({
  providedIn: 'root'
})
export class GeospatialService {

  constructor() { }

  meterDistance(edge: Edge) {
    const line = edgeToFeature(edge);
    return turfLength(line, { units: 'kilometers' }) * 1000;
  }
}
